import { ElMessage } from 'element-plus';

export default class NotificationService {
  public static notifySuccess(message?: string) {
    ElMessage({
      message: message || 'Success',
      type: 'success',
      showClose: true,
      zIndex: 5000,
    });
  }

  public static notifyFailure() {
    ElMessage({
      message: 'Something very unexpected happened. Our team is working on a solution already.',
      type: 'error',
      customClass: 'test-message',
      showClose: true,
      zIndex: 5000,
    });
    // this.notify('warning', 'Something very unexpected happened. Our team is working on a solution already.');
  }

  // public static notify(type: string, message: string): void {
  //   ElMessage({
  //     type,
  //     message,
  //   });
  // }

  public static announce(message: string) {
    ElMessage({
      // position: 'top-right',
      // multiLine: true,
      // color: 'success',
      // textColor: 'indigo-10',
      // icon: 'thumb_up',
      message,
    });
  }
}
